import segments from './reducers';

import * as segmentOperations from './operations';
import * as segmentTypes from './types';

export { segmentOperations, segmentTypes };

export default segments;
